import React, {useEffect, useRef} from 'react';
import {connect} from "react-redux";
import {SIDEBAR_NAVIGATION_CABINET_BUTTONS} from "../../../../constants";
import {FormattedMessage} from "react-intl";
import $ from "jquery";
import {animateButtons, hideButtons} from "../../../SqftUiFunctions";
import {addChangeValuePopup, setSQFTActiveButton, setSQFTMenuOpened} from "../../../../../../actions/sqftMenuFunctions";
import config from "../../../canvas/store/sqftConfig";
import {
  handleResetClick, handleResizeClick, handleRotateClick, handleSpacerClick, handleWallClick,
  resetEvents
} from "../../NavigationHelper";

const SqftToolMenuCabinet = (props) => {
  // other popups, modals and so on
  const {activeButton, menuOpened, setSQFTActiveButton, setSQFTMenuOpened} = props;
  const buttonRefs = useRef({});
  const expanded = activeButton
    && menuOpened !== "bumpout"
    && (menuOpened === "move" || Object.keys(SIDEBAR_NAVIGATION_CABINET_BUTTONS).some(buttonKey => menuOpened === buttonKey));

  useEffect(() => {
    const buttonEls = Object.values(buttonRefs.current);
    if (expanded) {
      animateButtons(buttonEls);
    } else {
      hideButtons(buttonEls);
    }

  }, [expanded]);

  const handleButtonClick = (buttonKey) => {
    setSQFTMenuOpened(buttonKey);
    setSQFTActiveButton(buttonKey);
    config.workspace.menuItemActive = buttonKey;
    resetEvents();
    switch (buttonKey) {
      case SIDEBAR_NAVIGATION_CABINET_BUTTONS.move:
        setSQFTMenuOpened('');
        break;
      case SIDEBAR_NAVIGATION_CABINET_BUTTONS.resize:
        setSQFTMenuOpened('');
        setSQFTActiveButton(SIDEBAR_NAVIGATION_CABINET_BUTTONS.resize);
        handleResizeClick();
        break;
      case SIDEBAR_NAVIGATION_CABINET_BUTTONS.rotate:
        handleRotateClick();
        break;
      case SIDEBAR_NAVIGATION_CABINET_BUTTONS.spacer:
        setSQFTMenuOpened('');
        setSQFTActiveButton(SIDEBAR_NAVIGATION_CABINET_BUTTONS.spacer);
        handleSpacerClick();
        break;
      case SIDEBAR_NAVIGATION_CABINET_BUTTONS.wall:
        setSQFTMenuOpened('');
        setSQFTActiveButton(SIDEBAR_NAVIGATION_CABINET_BUTTONS.wall);
        handleWallClick();
        break;
      case 'reset':
        handleResetClick();
        break;
    }

    $('.lightbox-option-selected').removeClass('lightbox-option-selected');
  };

  return (
    <nav className={"navigation side" + (expanded ? " expanded" : "")} data-side="navigation">
      <div className="navigation-list">
        {Object.keys(SIDEBAR_NAVIGATION_CABINET_BUTTONS).map((buttonKey) => (
          <button key={buttonKey}
                  ref={el => buttonRefs.current[buttonKey] = el}
                  className={"button button--" + buttonKey}
                  onClick={() => handleButtonClick(buttonKey)}>
            <span className="button-text">
              <FormattedMessage id={"sqft.navigation.submenu." + buttonKey}/>
            </span>
          </button>
        ))}
      </div>
    </nav>
  )
};

const mapStateToProps = (store) => ({
  menuOpened: store.sqftMenuState.menuOpened,
  activeButton: store.sqftMenuState.activeButton
});

const mapDispatchToProps = {
  setSQFTMenuOpened,
  setSQFTActiveButton,
  addChangeValuePopup,
};

export default connect(mapStateToProps, mapDispatchToProps)(SqftToolMenuCabinet);
